import React from "react";

const DialogIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M28.7479 24.8414C29.8857 23.2924 30.4834 21.4923 30.4834 19.595C30.4834 16.558 28.9084 13.7384 26.2513 11.9788C26.0062 9.27293 24.7428 6.76355 22.6303 4.83009C20.2944 2.69213 17.1953 1.51465 13.9039 1.51465C10.6125 1.51465 7.51347 2.69213 5.17752 4.83015C2.81361 6.99368 1.51176 9.87828 1.51176 12.9526C1.51176 15.3171 2.27402 17.5589 3.72305 19.4771L1.59426 24.7431C1.42162 25.1702 1.525 25.6592 1.85574 25.9798C2.07133 26.1887 2.35527 26.299 2.64374 26.299C2.79782 26.299 2.95321 26.2675 3.09999 26.2028L9.17164 23.5264C9.9339 23.8177 10.7192 24.0357 11.5226 24.18C12.3455 25.5334 13.5193 26.6795 14.9463 27.5138C16.5394 28.4451 18.3788 28.9428 20.2708 28.9571C20.2986 28.9592 20.3263 28.9614 20.3547 28.9614C21.6628 28.9614 22.9302 28.7354 24.1291 28.2891L28.8952 30.3901C29.042 30.4549 29.1974 30.4863 29.3515 30.4863C29.6399 30.4863 29.9239 30.3761 30.1395 30.1671C30.4702 29.8465 30.5736 29.3574 30.4009 28.9304L28.7479 24.8414ZM26.403 25.08L27.2579 27.1948L24.6076 26.0266C24.3211 25.9003 23.9951 25.8983 23.707 26.0212C22.6683 26.4644 21.556 26.6915 20.4005 26.6974C20.3852 26.6968 20.3701 26.6951 20.3546 26.6951C18.1244 26.6951 16.0174 25.8235 14.5454 24.3738C16.4117 24.2844 18.2411 23.8077 19.8721 22.9795C20.4294 22.6964 20.6517 22.0152 20.3687 21.4579C20.0857 20.9007 19.4045 20.6785 18.8471 20.9614C17.3457 21.724 15.6363 22.1271 13.9039 22.1271C12.3985 22.1271 10.9492 21.8344 9.59643 21.2572C9.30846 21.1343 8.9823 21.1361 8.69581 21.2625L4.73723 23.0076L6.07003 19.7106C6.22808 19.3196 6.1557 18.8732 5.88211 18.5523C4.50376 16.9352 3.77516 14.9988 3.77516 12.9526C3.77516 7.89367 8.3189 3.77806 13.9039 3.77806C19.4889 3.77806 24.0327 7.89367 24.0327 12.9526C24.0327 14.5865 23.5523 16.1906 22.6434 17.5914C22.3032 18.1157 22.4525 18.8165 22.9768 19.1567C23.5011 19.497 24.2019 19.3476 24.5422 18.8233C25.3488 17.5802 25.8876 16.2076 26.1368 14.7821C27.4626 16.0804 28.22 17.7905 28.22 19.595C28.22 21.1752 27.6567 22.6713 26.5909 23.9216C26.3173 24.2425 26.2449 24.689 26.403 25.08Z"
        fill="url(#paint0_linear_7509_13587)"
      />
      <path
        d="M11.9985 13.0007C11.9985 13.553 11.5508 14.0007 10.9985 14.0007C10.4462 14.0007 9.9985 13.553 9.9985 13.0007C9.9985 12.4484 10.4462 12.0007 10.9985 12.0007C11.5508 12.0007 11.9985 12.4484 11.9985 13.0007Z"
        fill="url(#paint1_linear_7509_13587)"
      />
      <path
        d="M14.9985 13.0007C14.9985 13.553 14.5508 14.0007 13.9985 14.0007C13.4462 14.0007 12.9985 13.553 12.9985 13.0007C12.9985 12.4484 13.4462 12.0007 13.9985 12.0007C14.5508 12.0007 14.9985 12.4484 14.9985 13.0007Z"
        fill="url(#paint2_linear_7509_13587)"
      />
      <path
        d="M17.9985 13.0007C17.9985 13.553 17.5508 14.0007 16.9985 14.0007C16.4462 14.0007 15.9985 13.553 15.9985 13.0007C15.9985 12.4484 16.4462 12.0007 16.9985 12.0007C17.5508 12.0007 17.9985 12.4484 17.9985 13.0007Z"
        fill="url(#paint3_linear_7509_13587)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7509_13587"
          x1="8.49964"
          y1="29.4292"
          x2="24.6784"
          y2="1.55583"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#05BAA4" />
          <stop offset="1" stopColor="#2046E9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7509_13587"
          x1="8.49964"
          y1="29.4292"
          x2="24.6784"
          y2="1.55583"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#05BAA4" />
          <stop offset="1" stopColor="#2046E9" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_7509_13587"
          x1="8.49964"
          y1="29.4292"
          x2="24.6784"
          y2="1.55583"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#05BAA4" />
          <stop offset="1" stopColor="#2046E9" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_7509_13587"
          x1="8.49964"
          y1="29.4292"
          x2="24.6784"
          y2="1.55583"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#05BAA4" />
          <stop offset="1" stopColor="#2046E9" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DialogIcon;
